import { render, staticRenderFns } from "./TextRedactor.vue?vue&type=template&id=204279fa&scoped=true"
import script from "./TextRedactor.vue?vue&type=script&lang=js"
export * from "./TextRedactor.vue?vue&type=script&lang=js"
import style0 from "./TextRedactor.vue?vue&type=style&index=0&id=204279fa&prod&lang=scss&scoped=true"
import style1 from "./TextRedactor.vue?vue&type=style&index=1&id=204279fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204279fa",
  null
  
)

export default component.exports